"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategoriesPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var console_1 = require("../../../../reducers/slices/console");
var add_category_1 = __importDefault(require("./components/product_details/add_category"));
var main_1 = require("../../../../reducers/slices/main");
var category_1 = require("../../../../reducers/slices/categories/category");
var react_csv_1 = require("react-csv");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var get_category_thunk_1 = require("../../../../reducers/slices/products/categories/thunks/get_category_thunk");
var remove_category_1 = require("../../../../api/calls/product/category/remove_category");
var category_list_1 = require("../../../../api/calls/product/category/category_list");
var useSearchDebounce_1 = require("../../../../hooks/useSearchDebounce");
var pages_1 = require("../../../../constants/pages");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var ProductCategoriesPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, useSearchDebounce_1.useSearchDebounce)(), search = _a[0], setSearch = _a[1];
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }), categories = _b.categories, pagination = _b.pagination;
    var _c = (0, react_1.useState)([]), allCategories = _c[0], setAllCategories = _c[1];
    var _d = (0, react_1.useState)(1), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = (0, react_1.useState)(10), rowsPerPage = _e[0], setRowsPerPage = _e[1];
    var client_token = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).client_token;
    var csvData = [];
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Product Categories"));
    }, []);
    (0, react_1.useEffect)(function () {
        if (client_token) {
            dispatch((0, category_1.setLoaded)(true));
            dispatch((0, get_category_thunk_1.get_category_thunk)(__assign({}, pagination)));
            (0, category_list_1.get_category_list)({}, client_token).then(function (response) {
                if (response.success) {
                    var product_category_list = response.content.product_category_list;
                    processCategories(product_category_list);
                }
                else {
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when fetching all categories!", messages: [response.message] }));
                }
            });
        }
    }, [client_token]);
    var processCategories = (0, react_1.useCallback)(function (categories) {
        if (categories === null || categories === void 0 ? void 0 : categories.length) {
            categories.map(function (category) {
                csvData.push({
                    category_id: category === null || category === void 0 ? void 0 : category._id,
                    category_name: category === null || category === void 0 ? void 0 : category.name,
                    is_sub_category: category === null || category === void 0 ? void 0 : category.is_sub_category,
                    parent_id: category === null || category === void 0 ? void 0 : category.parent_id,
                });
                if (category.sub_categories && category.sub_categories.length) {
                    for (var _i = 0, _a = category.sub_categories; _i < _a.length; _i++) {
                        var subCategory = _a[_i];
                        csvData.push({
                            category_id: subCategory === null || subCategory === void 0 ? void 0 : subCategory._id,
                            category_name: subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
                            is_sub_category: subCategory === null || subCategory === void 0 ? void 0 : subCategory.is_sub_category,
                            parent_id: subCategory === null || subCategory === void 0 ? void 0 : subCategory.parent_id,
                        });
                    }
                }
            });
            setAllCategories(csvData);
        }
    }, [allCategories === null || allCategories === void 0 ? void 0 : allCategories.length]);
    var headers = [
        { label: "Category ID", key: "category_id" },
        { label: "Category Name", key: "category_name" },
        { label: "Is SubCategory", key: "is_sub_category" },
        { label: "Parent ID", key: "parent_id" },
    ];
    (0, react_1.useEffect)(function () {
        onSearch(search);
    }, [search]);
    var getCategories = function (query) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch((0, get_category_thunk_1.get_category_thunk)(query))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); };
    var onSearch = function (search_string) {
        getCategories(__assign(__assign({}, pages_1.initialPaginationValues), (search_string && { search_string: search_string })));
    };
    var onPageChange = function (page) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCurrentPage(page);
                    setRowsPerPage(rowsPerPage);
                    return [4 /*yield*/, dispatch((0, get_category_thunk_1.get_category_thunk)(__assign(__assign({}, pagination), { page: page })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var onRowsPerPageChange = function (size) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRowsPerPage(size);
                    return [4 /*yield*/, dispatch((0, get_category_thunk_1.get_category_thunk)(__assign(__assign({}, pagination), { size: size })))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-end items-center gap-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "w-32 rounded-md bg-white py-2 text-center" }, { children: (0, jsx_runtime_1.jsx)(react_csv_1.CSVLink, __assign({ data: allCategories, headers: headers, filename: "category_types" }, { children: "Export CSV" })) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Add Category", endIcon: pro_light_svg_icons_1.faPlus, size: "small", backgroundColor: "bg-success", textColor: "text-white", onClick: function () {
                            dispatch((0, main_1.setContentModal)({
                                title: "Add Product Category",
                                content: (0, jsx_runtime_1.jsx)(add_category_1.default, { category: null, isEditing: false }),
                            }));
                        } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TextInputControl, { label: "Search", borderColor: "border-borders", backgroundColor: "bg-white", endIcon: pro_solid_svg_icons_1.faSearch, size: "small", onChange: function (e) {
                            setSearch(e);
                        } })] })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { columns: [
                    {
                        displayKey: "image",
                        label: "Image",
                        formatter: function (category) {
                            if (category) {
                                return (0, jsx_runtime_1.jsx)("img", { className: "w-10 aspect-square rounded-lg", src: category === null || category === void 0 ? void 0 : category.image_url });
                            }
                            else {
                                return "";
                            }
                        },
                    },
                    {
                        displayKey: "name",
                        label: "Category Name",
                    },
                    {
                        displayKey: "description",
                        label: "Category Description",
                    },
                    {
                        displayKey: "is_sub_category",
                        label: "Is Sub Category",
                        formatter: function (category) {
                            return (category === null || category === void 0 ? void 0 : category.is_sub_category) ? "Yes" : "No";
                        },
                    },
                    {
                        displayKey: "is_online",
                        label: "Online",
                        formatter: function (category) {
                            if (!(category === null || category === void 0 ? void 0 : category.is_online)) {
                                return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "text-disabled", icon: pro_solid_svg_icons_1.faCircleMinus });
                            }
                            else {
                                return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { className: "text-success", icon: pro_solid_svg_icons_1.faCircleCheck });
                            }
                        },
                    },
                    {
                        displayKey: "order_number",
                        label: "Order Number",
                        formatter: function (category) {
                            return (category === null || category === void 0 ? void 0 : category.order_number) ? category === null || category === void 0 ? void 0 : category.order_number : "Not Set";
                        },
                    },
                ], data: categories, onRowClicked: function (data) {
                    dispatch((0, main_1.setContentModal)({
                        title: "Edit Product Category",
                        content: (0, jsx_runtime_1.jsx)(add_category_1.default, { category: data, isEditing: true }),
                    }));
                }, rowActions: [
                    {
                        label: "Edit",
                        onClick: function (data) {
                            dispatch((0, main_1.setContentModal)({
                                title: "Edit Product Category",
                                content: (0, jsx_runtime_1.jsx)(add_category_1.default, { category: data, isEditing: true }),
                            }));
                        },
                    },
                    {
                        label: "Delete",
                        onClick: function (data) {
                            dispatch((0, main_1.setContentModal)({
                                title: "Confirm deletion of ".concat(data === null || data === void 0 ? void 0 : data.name, " category"),
                                content: ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex pt-4 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Are you sure you want to delete this category?", textColor: "text-inputText" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Cancel", size: "small", backgroundColor: "bg-slate-300", textColor: "text-dark", onClick: function () { return dispatch((0, main_1.setContentModal)(null)); } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Continue", size: "small", onClick: function () {
                                                (0, remove_category_1.remove_product_category)({
                                                    _id: data === null || data === void 0 ? void 0 : data._id,
                                                }).then(function (response) {
                                                    if (response.success) {
                                                        dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                                                        dispatch((0, main_1.setContentModal)(null));
                                                        dispatch((0, get_category_thunk_1.get_category_thunk)(__assign({}, pagination)));
                                                    }
                                                    else {
                                                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when deleting the category!", messages: [response.message] }));
                                                    }
                                                });
                                            } })] }))),
                            }));
                        },
                    },
                ], hasShadow: true, pagination: {
                    rowsPerPageOptions: [10, 15, 20],
                    currentPage: currentPage,
                    rowsPerPage: rowsPerPage,
                    totalRecords: pagination.countTotal,
                    onPageChange: onPageChange,
                    onRowsPerPageChange: onRowsPerPageChange,
                }, colors: pages_1.tableColorConfig })] })));
};
exports.ProductCategoriesPage = ProductCategoriesPage;
